import vue from 'vue';
import axios from 'axios';
import DefaultLayout from '@/layouts/Default.vue';
import MinimalLayout from '@/layouts/Minimal.vue';

import AutengoLogin from '@/views/auth/Login.vue';
import AlzuraLogin from '@/views/auth/AlzuraLogin.vue';


export default [
  {
    path: '/',
    component: DefaultLayout,
    meta: { checkAuth: true },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/dashboard/Dashboard.vue'),
      },
      {
        path: '/dashboard',
        name: 'newHome',
        component: () => import('@/views/dashboard/Dashboard.vue'),
      },
      {
        path: '/inventory/:type', props: true, name: 'VehicleInventoryList', component: () => import('@/views/vehicle/VehicleInventory.vue'),
      },
      {
        path: '/vehicle/:sellingId', name: 'vehicleDetail', props: true, component: () => import('@/views/vehicle/VehicleDetail.vue'),
      },
      {
        path: '/testdrive', name: 'testdriveOverview', component: () => import('@/views/testdrive/TestdriveOverview'),
      },
      {
        path: '/testdrive/:testdriveId',
        name: 'testdriveDetail',
        props: true,
        component: () => import('@/views/testdrive/TestdriveDetail'),
      },
      {
        path: '/inserate', name: 'inserateOverview', component: () => import('@/views/inserate/InserateOverview.vue'),
      },
      {
        path: '/customer', name: 'customerOverview', component: () => import('@/views/customer/CustomerOverview.vue'),
      },
      {
        path: '/customer/:id', name: 'customerDetail', props: true, component: () => import('@/views/customer/CustomerDetail.vue'),
      },
      {
        path: '/contact', name: 'contactOverview', component: () => import('@/views/contact/ContactOverview.vue'),
      },
      {
        path: '/contact/:id', name: 'contactDetail', props: true, component: () => import('@/views/contact/ContactDetail.vue'),
      },
      {
        path: '/organization/:id', name: 'organizationDetail', props: true, component: () => import('@/views/organization/OrganizationDetail.vue'),
      },
      {
        path: '/opportunity', name: 'opportunityOverview', component: () => import('@/views/opportunity/OpportunityOverview.vue'),
      },
      {
        path: '/opportunity/:id', name: 'opportunityDetail', props: true, component: () => import('@/views/opportunity/OpportunityDetail.vue'),
      },
      {
        path: '/opportunitymail/:opportunityId',
        name: 'opportunityMailDetail',
        props: true,
        component: () => import('@/views/opportunity/OpportunityMailDetail.vue'),
      },
      {
        path: '/opportunity/create', name: 'opportunityDetailCreate', props: true, component: () => import('@/views/opportunity/OpportunityDetail.vue'),
      },
      {
        path: '/document', name: 'documentsOverview', component: () => import('@/views/document/DocumentOverview.vue'),
      },
      {
        path: '/document/:id', name: 'documentDetail', props: true, component: () => import('@/components/document/dashboard/DocumentPdfDetail.vue'),
      },
      {
        path: '/document/template/create', props: true, name: 'templateCreate', component: () => import('@/views/document/CreateDocumentTemplate.vue'),
      },
      {
        path: '/document/template/:id', name: 'template', props: true, component: () => import('@/views/document/DocumentTemplate.vue'),
      },
      {
        path: '/document/create/:templateId', name: 'documentCreate', props: true, component: () => import('@/views/document/CreateDocument.vue'),
      },
      {
        path: '/email/authresult', name: 'authresult', component: () => import('@/views/email/EmailAuthResult.vue'),
      },
      {
        path: '/email/:folder', props: true, name: 'emailThreadOverview', component: () => import('@/views/email/EmailThreadOverview.vue'),
      },
      {
        path: '/email/new', name: 'newEmailThreadDetail', props: { isNew: true }, component: () => import('@/views/email/EmailThreadDetail.vue'),
      },
      {
        path: '/email/detail/:encodedThreadId', name: 'emailThreadDetail', props: true, component: () => import('@/views/email/EmailThreadDetail.vue'),
      },
      {
        path: '/invoice', name: 'invoiceOverview', component: () => import('@/views/invoice/InvoiceOverview.vue'),
      },
      {
        path: '/invoice/:id', name: 'invoiceDetail', props: true, component: () => import('@/components/invoice/dashboard/InvoicePdfDetail.vue'),
      },
      {
        path: '/invoice/template/create', props: true, name: 'invoiceTemplateCreate', component: () => import('@/views/invoice/CreateInvoiceTemplate.vue'),
      },
      {
        path: '/invoice/template/:id', name: 'invoiceTemplate', props: true, component: () => import('@/views/invoice/InvoiceTemplate.vue'),
      },
      {
        path: '/invoice/create/:templateId', name: 'invoiceCreate', props: true, component: () => import('@/views/invoice/CreateInvoice.vue'),
      },
      {
        path: '/invoices', name: 'invoicesList', component: () => import('@/views/invoices/InvoicesList.vue'),
      },
      {
        path: '/invoices/draft/:invoiceId',
        name: 'invoicesDraft',
        props: true,
        component: () => import('@/views/invoices/InvoicesDraftDetail.vue'),
      },
      {
        path: '/invoices/:invoiceId',
        name: 'invoicesPreview',
        props: true,
        component: () => import('@/views/invoices/InvoicesPreview.vue'),
      },
      {
        path: '/license-plates', name: 'licensePlateList', component: () => import('@/views/licensePlate/LicensePlateList.vue'),
      },
      {
        path: '/license-plates/:licensePlateId',
        name: 'licensePlateDetail',
        props: true,
        component: () => import('@/views/licensePlate/LicensePlateDetail.vue'),
      },
      {
        path: '/settings',
        name: 'settings',
        meta: { isBranchOwner: true },
        component: () => import('@/views/settings/Settings.vue'),
      },
      {
        path: '/profile-settings', name: 'profile-settings', component: () => import('@/views/settings/ProfileSettings.vue'),
      },
      {
        path: '/upgrade', name: 'upgradeAccountView', component: () => import('@/views/payment/UpgradeAccountView.vue'),
      },
      {
        path: '/subscribe', name: 'subscribeView', component: () => import('@/views/payment/Subscribe.vue'),
      },
      {
        path: '/maxvin', name: 'maxVin', component: () => import('@/views/payment/MaxVin.vue'),
      },
      {
        path: '/import/:branchId', name: 'inserateImporter', props: true, component: () => import('@/views/import/Importer.vue'),
      },
      {
        path: '/import-logs', name: 'importLogDetail', component: () => import('@/views/import/ImportLogDetailView.vue'),
      },
      {
        path: '/user', name: 'userOverview', meta: { isBranchOwner: true }, component: () => import('@/views/user/UserOverview.vue'),
      },
      {
        path: '/user/:userId', name: 'userDetail', props: true, meta: { isBranchOwner: true }, component: () => import('@/views/user/UserDetail.vue'),
      },
      {
        path: '/branch', name: 'branchOverview', meta: { isDealerOwner: true }, component: () => import('@/views/branch/BranchOverview.vue'),
      },
      {
        path: '/marketplace',
        component: () => import('@/views/marketplace/MarketplaceOverview.vue'),
        children: [
          {
            path: '', name: 'marketplaceAllOverview', component: () => import('@/components/marketplace/overview/MarketplaceAllOverview.vue'),
          },
          {
            path: 'fav', name: 'marketplaceFavOverview', component: () => import('@/components/marketplace/overview/MarketplaceFavOverview.vue'),
          },
          {
            path: 'bid', name: 'marketplaceBidOverview', component: () => import('@/components/marketplace/overview/MarketplaceBidOverview.vue'),
          },
          {
            path: 'bought', name: 'marketplaceBoughtOverview', component: () => import('@/components/marketplace/overview/MarketplaceBoughtOverview.vue'),
          },
        ],
      },
      {
        path: '/marketplace/carsale24/:vehicleId',
        name: 'marketplaceCarsale24Detail',
        props: true,
        component: () => import('@/views/marketplace/MarketplaceCarsale24Detail.vue'),
      },
      {
        path: '/eln-marketplace',
        name: 'elnMarketPlace',
        component: () => import('@/views/eln-market/ElnMarketOverview.vue'),
        beforeEnter: (to, from, next) => {
          if (import.meta.env.VUE_APP_WHITELABEL !== 'eln') next('/marketplace');
          next();
        },
      },
      {
        path: '/eln-marketplace/vehicle/:type',
        name: 'elnVehicles',
        props: true,
        component: () => import('@/views/eln-market/ElnVehicleList.vue'),
        beforeEnter: (to, from, next) => {
          if (import.meta.env.VUE_APP_WHITELABEL !== 'eln') next('/marketplace');
          next();
        },
      },
      {
        path: '/eln-marketplace/:vehicleId',
        name: 'elnMarketPlaceDetails',
        props: true,
        component: () => import('@/views/eln-market/ElnMarketDetail.vue'),
        beforeEnter: (to, from, next) => {
          if (import.meta.env.VUE_APP_WHITELABEL !== 'eln') next('/marketplace');
          next();
        },
      },
    ],
  },
  {
    path: '/admin',
    component: DefaultLayout,
    meta: { checkAuth: true, isAdmin: true },
    children: [
      {
        path: 'dealer', name: 'adminDealerOverview', component: () => import('@/views/admin/DealerOverview.vue'),
      },
      {
        path: 'dealer/:dealerId', name: 'adminDealerDetail', props: true, component: () => import('@/views/admin/DealerDetail.vue'),
      },
      {
        path: 'dashboard', name: 'adminDashboard', props: true, component: () => import('@/views/admin/AdminDashboard.vue'),
      },
      {
        path: 'system', name: 'systemDashboard', props: true, component: () => import('@/views/admin/SystemDashboard.vue'),
      },
      {
        path: 'stripe', name: 'stripeInvoices', props: true, component: () => import('@/views/admin/StripeInvoices.vue'),
      },
      {
        path: 'matcher/catalog/model',
        name: 'jatoModelMatcher',
        component: () => import('@/views/admin/JatoModelMatcher.vue'),
      },
      {
        path: 'matcher/catalog/make',
        name: 'jatoMakeMatcher',
        component: () => import('@/views/admin/JatoMakeMatcher.vue'),
      },
      {
        path: 'matcher/platform',
        name: 'platformModelMatcher',
        component: () => import('@/views/admin/PlatformModelMatcher.vue'),
      },
      {
        path: 'matcher/catalog/group',
        name: 'modelGroupManager',
        component: () => import('@/views/admin/ModelGroupManager.vue'),
      },
      {
        path: 'notifications',
        name: 'notificationManager',
        component: () => import('@/views/admin/NotificationManager.vue'),
      },
    ],
  },
  {
    path: '/login',
    component: MinimalLayout,
    children: [
      {
        path: '',
        name: 'login',
        get component() {
          if (import.meta.env.VUE_APP_WHITELABEL === 'alzura') {
            return AlzuraLogin;
          }
          return AutengoLogin;
        },
      },
    ],
  },
  {
    path: '/forgot-password',
    component: MinimalLayout,
    children: [
      { path: '', name: 'forgotPassword', component: () => import('@/views/auth/ForgotPassword.vue') },
    ],
  },
  {
    path: '/resetPassword',
    component: MinimalLayout,
    children: [
      { path: '', name: 'resetPassword', component: () => import('@/views/auth/ResetPassword.vue') },
    ],
  },
  {
    path: '/createpassword',
    component: MinimalLayout,
    children: [
      { path: '', name: 'createpassword', component: () => import('@/views/auth/CreatePassword.vue') },
    ],
  },
  {
    path: '/oauth/result',
    component: MinimalLayout,
    children: [
      { path: '', name: 'oauthresult', component: () => import('@/views/auth/OAuthResult.vue') },
    ],
  },
  {
    path: '/reset2FA',
    redirect: (to) => {
      const { resetToken } = to.query;

      axios.get(`/v2/security/otp/reset?resetToken=${resetToken}`, { errorNotification: false }).then(
        () => {
          vue.prototype.$notifyUserInteraction.success('Die 2-Faktor-Authentifizierung wurde erfolgreich zurückgesetzt!');
        },
        (error) => {
          console.error(error);
          vue.prototype.$notifyUserInteraction.error('Es ist ein Fehler beim Zurücksetzen der 2-Faktor-Authentifizierung aufgetreten!');
        },
      );

      return { name: 'login', query: {} };
    },
  },
  {
    path: '/payment',
    component: MinimalLayout,
    children: [
      { path: '', name: 'payment', component: () => import('@/views/payment/Payment.vue') },
      { path: 'overdue', name: 'paymentOverdue', component: () => import('@/views/payment/PaymentOverdue.vue') },
    ],
  },
  {
    path: '/notactive',
    component: MinimalLayout,
    children: [
      { path: '', name: 'notactive', component: () => import('@/views/payment/NotActive.vue') },
    ],
  },
  {
    path: '/callback',
    component: MinimalLayout,
    children: [
      { path: '', name: 'callback', component: () => import('@/views/auth/Callback.vue') },
    ],
  },
  {
    path: '/catalog/import/:id/print',
    component: MinimalLayout,
    children: [
      { path: '', name: 'catalog-import-print', component: () => import('@/views/catalog/ImportRunPrint.vue') },
    ],
  },
  {
    path: '/print/invoices/:token',
    name: 'invoicesPrintView',
    component: () => import('@/views/invoices/InvoicesPrintView.vue'),
  },
  {
    path: '/print/document/:token',
    name: 'documentPrintView',
    component: () => import('@/views/document/DocumentPrintView.vue'),
  },
  {
    path: '/demo/unified-search',
    component: MinimalLayout,
    children: [
      {
        path: '',
        name: 'unifiedSearchDemo',
        component: () => import('@/views/demo/UnifiedSearchDemo.vue'),
      },
    ],
  },
];
